/**
 * FVrad logo - web (uses SVG)
 * Light logo for light backgrounds, dark logo for dark backgrounds
 */

import React from 'react';
import { Image, StyleSheet, View } from 'react-native';

const logoLight = require('../assets/branding/logo.svg') as string;
const logoDark = require('../assets/branding/logo-dark.svg') as string;

type LogoProps = {
  width?: number;
  height?: number;
  style?: object;
  dark?: boolean;
};

export function Logo({ width = 160, height = 48, style, dark = false }: LogoProps) {
  const logoSource = dark ? logoDark : logoLight;
  return (
    <View style={[styles.container, style]}>
      <Image
        source={{ uri: logoSource }}
        style={{ width, height }}
        resizeMode="contain"
        accessibilityLabel="FVrad logo"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 4,
  },
});
